import { Injector } from "@angular/core";
import { LookupGetService } from "../../../../service/lookup-service/lookup-get.service";
import { ListView } from "../../../Data/ListView";
import { Art57Node } from "../Art57Node";
import { Art57NodeList } from "../Art57NodeList";
import { TreeNodePharmaceuticalFormsType } from "../Entity/TreeNodePharmaceuticalFormsType";
import { Art57Section } from "../../../Art57Section/Art57Section";
import { environment } from "../../../../../../environments/environment";

export class TreeNodePharmaceuticalFormList extends Art57NodeList {
    constructor(injector: Injector, parent: Art57Node) {
      super(injector, new ListView(), 'Pharmaceutical Forms ({param})');
      this.parent = parent;
      this.labelNodeName = 'Pharmaceutical Forms';
      this.expanded = true;
    }
  
    override refreshLabel(): void {
      this.label = this.labelTemplate.replace(
        '{param}',
        this.getLabelParamFromChildren()
      );
    }
  
    override createChildTemplate(params: any): Art57Node[] | null {
      let nodeCreated = new TreeNodePharmaceuticalFormsType(this.ioc!, this);
      nodeCreated.data.model.type_Term = params.nodeType;
      if ((params.operationType===1) && (this.ioc!.get(Art57Section).isCreateAndSendProductSection() || this.ioc!.get(Art57Section).isMedicinalProductSection())) {
        nodeCreated.data.model.localnumber = this.ioc!.get(LookupGetService).getLocalNumber();
      }
      nodeCreated.refreshLabel();
      this.children?.push(nodeCreated);
      this.refreshLabel();
      return [nodeCreated];
    }
  
    override getMessage(): any {
      let pharmaceuticalforms: any[] = [];
      this.children?.forEach((node) => {
        let pharmaceuticalform = node as TreeNodePharmaceuticalFormsType;
        let art57Message = pharmaceuticalform.getMessage();
        if (art57Message != null) {
          pharmaceuticalforms.push(art57Message);
        }
      });
  
      if (this.children!.length > 0) {
        return {
          pharmaceuticalforms: { pharmaceuticalform: pharmaceuticalforms },
        };
      } else {
        return;
      }
    }
  
    override isStandardTerminology():boolean{
      return true;
    }

    override getHeaders(): string[] {
      return ['EV Code', 'Operation Type', 'Type', 'Pharmaceutical Form'];
    }
  
    override cloneNode(newParent: Art57Node): Art57Node|undefined {
      let clonedNode: TreeNodePharmaceuticalFormList =
        new TreeNodePharmaceuticalFormList(this.ioc!, newParent);
  
      this.children?.forEach((child) => {
        let childToClone = child as Art57Node;
        let clonedChildren = childToClone.cloneNode(clonedNode);
        if (clonedChildren) {
            clonedNode.children?.push(clonedChildren);
            clonedChildren.refreshLabel();
        }
      });
  
      clonedNode.refreshLabel();  
      clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning ||environment.userPreferences.alwaysAutoexpandNodes)

  
      return clonedNode;
    }
  }